import { call, put } from 'redux-saga/effects'
import { ApiResponse } from 'apisauce'

import api from 'src/services/api'

import { ClientNotifyCatch } from 'src/config/bugsnag'
import findBasicApiResponseErrors from 'src/services/findBasicApiResponseErrors'
import i18n from 'src/config/i18n'
import { ResponseDataRequests } from './types'
import * as Actions from './actions'

export function* getBedrooms({
  payload: { options }
}: ReturnType<typeof Actions.getBedrooms>) {
  // const {
  //   me: { organization }
  // } = yield select((state: ApplicationState) => state)

  // const params = []

  // if (options.request_agency_ids && options.request_agency_ids.length) {
  //   params.push(`request_agency_ids=${options.request_agency_ids.join(',')}`)
  // }

  // if (options.request_ids && options.request_ids.length) {
  //   params.push(`request_ids=${options.request_ids.join(',')}`)
  // }

  try {
    const response: ApiResponse<ResponseDataRequests> = yield call(
      api.get,
      `/partners/${options.partner_id}/hotels/${
        options.partner_hotel_id
      }/rooms?&page_size=10&page=${options.page || 1}`
    )

    if (response.ok) {
      const { partner_hotel_rooms } = response.data
      yield put(Actions.getBedroomsSuccess({ partner_hotel_rooms }))
      return
    }

    const message = findBasicApiResponseErrors(response)
    yield put(Actions.getBedroomsFailure(message))
  } catch (err) {
    ClientNotifyCatch('Saga getPartners', err)
    const message = i18n.t('common.response.unexpected-error')
    yield put(Actions.getBedroomsFailure(message))
  }
}

export function* sendBedrooms({
  payload: { partner_hotel_rooms }
}: ReturnType<typeof Actions.sendBedrooms>) {
  try {
    // const {
    //   partners,
    //   me: { user }
    // } = yield select((state: ApplicationState) => state)
    const responsePayload = { partner_hotel_rooms }
    const { partner_id, partner_hotel_id } = partner_hotel_rooms[0]
    // let response: ApiResponse<ResponseDataRequests>

    const response: ApiResponse<ResponseDataRequests> = yield call(
      api.post,
      `/partners/${partner_id}/hotels/${partner_hotel_id}/rooms`,
      responsePayload
    )

    if (response.ok) {
      yield put(Actions.sendBedroomsSuccess())
      return
    }

    const message = findBasicApiResponseErrors(response)
    yield put(Actions.sendBedroomsFailure(message))
  } catch (err) {
    ClientNotifyCatch('Saga sendPartner', err)
    const message = i18n.t('common.response.unexpected-error')
    yield put(Actions.sendBedroomsFailure(message))
  }
}
